<template>
  <v-form>
    <v-container
      fluid>
      <v-row
        dense>
        <v-col
          md=6>
          <v-text-field
            v-model="inquirer"
            label="お名前(任意)"
            required/>
        </v-col>
      </v-row>
      <v-row
        dense>
        <v-col
          md=6>
          <v-text-field
            v-model="email"
            label="あなたのメールアドレス"
            type="text"
            v-validate="'required|email'"
            data-vv-name="email"
            data-vv-as="メールアドレス"
            :error-messages="errors.collect('email')"
            required
            />
        </v-col>
      </v-row>
      <v-row
        dense>
        <v-col
          md=6>
          <v-select
            v-model="category"
            label="お問い合わせの種類"
            :items="categories"
            v-validate="'required'"
            data-vv-name="category"
            data-vv-as="お問い合わせの種類"
            :error-messages="errors.collect('category')"
            />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea
            v-model="content"
            label="お問い合わせ内容"
            type="text"
            outlined
            rows=12
            v-validate="'required'"
            data-vv-name="content"
            data-vv-as="お問い合わせ内容"
            :error-messages="errors.collect('content')"
            required/>
        </v-col>
      </v-row>
      <v-row
        dense>
        <v-col>
          <v-btn
            outlined
            rounded
            color="primary"
            @click="submit">送信</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="annotation--text">
        <span>土日祝日等、当社休業日にお問い合わせ頂いた場合は、翌営業日以降のご回答となります事、ご了承下さい。<br>
        万が一、問い合わせが動作しない場合は <a href="mailto:info@nuco.co.jp">info@nuco.co.jp</a> までご連絡ください</span>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>


<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    categories: {
      type: Array
    }
  },
  data () {
    return {

    }
  },
  methods: {
    updateValue(diff) {
      this.$emit('input', {...this.value, ...diff})
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('submit-button-click')
        }
      })
    }
  },
  computed: {
    inquirer: {
      get () {
        return this.value.inquirer
      },
      set (inquirer) {
        this.updateValue({ inquirer })
      }
    },
    email: {
      get () {
        return this.value.email
      },
      set (email) {
        this.updateValue({ email })
      }
    },
    category: {
      get () {
        return this.value.category
      },
      set (category) {
        this.updateValue({ category })
      }
    },
    content:{
      get () {
        return this.value.content
      },
      set (content){
        this.updateValue({ content })
      }
    }
  }
}
</script>

<style scoped>
  .annotation--text {
    font-size: 0.8rem;
    color: grey
  }
</style>

